
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
function setcookie(cookieName, cookieValue, expires = 14) {
    var today = new Date();
    if (expires == 0) { var expire = 0; }
    else {
        var expire = new Date();
        expire.setTime(today.getTime() + 3600000 * 24 * expires);
        expire = expire.toGMTString();
    }
    document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";path=/;expires=" + expire;
}
function processObjects(array) {
    let bundleObjects = [];
    let otherObjects = [];
    array.forEach(item => {
        if (Array.isArray(item.bundles) && item.bundles.length > 0) {
            bundleObjects.push(item);
        } else {
            otherObjects.push(item);
        }
    });
    return { bundleObjects, otherObjects };
}
function checkDiscountCode(code) {
    if (discountCodes.length > 0) {
        var code = (typeof code !== "undefined") ? code : getCookie("discount_code");
        if (!code && getCookie('discount_code_last')) {
            code = getCookie('discount_code_last');
            setcookie('discount_code', code);
        }
        var decodecCode = decodeURI(code);
        var crypCode = (code) ? md5(decodecCode.toUpperCase()) : false;
        // console.log(code, crypCode);
        if (crypCode && discountCodes.includes(crypCode)) {
            var returnCode = code.toUpperCase();
            return decodeURI(returnCode);
        } else { return false; }
    } else { return false; }
}
function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));
}
function getCurrentRedirect() {
    var currentURL = window.location.href;
    var uselessURL = window.location.protocol + '//' + window.location.hostname;
    var currentRedirect = currentURL.replace(uselessURL, "");
    return currentRedirect;
}
function updateSaleBadge(priceContainer, final_price, original_price) {
    let productWrapper = priceContainer;
    let maxLoop = 10;
    do {
        productWrapper = productWrapper.parentElement;
        maxLoop--;
    }
    while (productWrapper && productWrapper.tagName != "PRODUCT-CARD" && !productWrapper.classList.contains('product-info__price') && maxLoop > 1)

    if (productWrapper && maxLoop > 0) {
        let discountSaleBadge = productWrapper.querySelector('on-sale-badge.discount-badge');
        if (discountSaleBadge && !discountSaleBadge.parentElement.classList.contains('crawled')) {
            let newPercentage = parseInt(((original_price - final_price) / original_price) * 100) + "%";
            // console.log('updateSaleBadge ', priceContainer, final_price, original_price, newPercentage)
            discountSaleBadge.querySelector('span').innerText = window.themeVariables.strings.discount_badge.replace('[]', newPercentage);
            discountSaleBadge.parentElement.classList.add('crawled');
        }
        let discountText = productWrapper.querySelector('.discount-badge.discount-text');
        // console.log("discountText ", discountText, productWrapper)
        if (discountText && extraGlobalDiscount) {
            let newPrice = final_price * (1 - (extraGlobalDiscount / 100));
            let newPercentage2 = parseInt(((original_price - newPrice) / original_price) * 100);
            discountText.innerText = window.themeVariables.strings.discount_text.replace('[]', newPercentage2);
            discountText.parentElement.classList.add('crawled');
        }
    }
}

function updateDiscountTextBadge() {

    let priceLists = document.querySelectorAll('price-list');
    priceLists.forEach(function (priceContainer) {
        let salePrice = priceContainer.dataset.salePrice,
            comparePrice = priceContainer.dataset.comparePrice,
            original_price = comparePrice;
        if (parseInt(comparePrice) == 0 || comparePrice == "" || comparePrice == "null") {
            original_price = salePrice;
        }

        let productWrapper = priceContainer;
        let maxLoop = 10;
        do {
            productWrapper = productWrapper.parentElement;
            maxLoop--;
        }
        while (productWrapper && productWrapper.tagName != "PRODUCT-CARD" && !productWrapper.classList.contains('product-info__price') && maxLoop > 1)

        if (productWrapper && maxLoop > 0) {
            let discountText = productWrapper.querySelector('.discount-badge.discount-text');
            // console.log("discountText ", discountText, productWrapper)
            if (discountText && extraGlobalDiscount && !discountText.classList.contains('crawled')) {
                let newPrice = salePrice * (1 - (extraGlobalDiscount / 100));
                let newPercentage2 = parseInt(((original_price - newPrice) / original_price) * 100);
                discountText.innerText = window.themeVariables.strings.discount_text.replace('[]', newPercentage2);
                discountText.classList.add('crawled');
            }
        }
    });


}
function calculateDiscounts() {
    var checkCode = checkDiscountCode();
    var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    console.log(' calculateDiscounts ', checkCode)
    if (checkCode && transferedEvents && transferedEvents.length > 0) {
        document.dispatchEvent(new CustomEvent('update-bundle-price'));
        let priceLists = document.querySelectorAll('price-list');
        priceLists.forEach(function (priceContainer) {
            if (!priceContainer.classList.contains('crawled')) {
                let salePrice = priceContainer.dataset.salePrice,
                    comparePrice = priceContainer.dataset.comparePrice,
                    startFromText = priceContainer.dataset.priceMin;
                if (salePrice && salePrice > 0) {
                    let discountEvent = transferedEvents[0];
                    if (transferedEvents.length > 1) {// different discounts per tags
                        let product_tags = priceContainer.dataset.productTags.split(',');
                        //default percentage for no product tags matched
                        let default_filter_events = transferedEvents.filter((event_) => { return event_.product_tags.length == 0; });
                        discountEvent = default_filter_events[0];
                        if (product_tags.length > 0) {
                            default_filter_events = transferedEvents.filter((event_) => { return event_.product_tags[0] != "" && product_tags.indexOf(event_.product_tags[0]) > -1; });
                        }
                        console.log("default_filter_events ", default_filter_events)
                        if (default_filter_events.length > 0) {
                            discountEvent = default_filter_events[0];
                        }
                    }
                    let discount_percentage = discountEvent.discount_value / 100.0;
                    let newSalePrice = salePrice * (1 - discount_percentage);
                    priceContainer.querySelector('.discount-content sale-price').innerText = startFromText + formatMoney(newSalePrice, currencyFormat);
                    if (!priceContainer.querySelector('.discount-content sale-price').classList.contains('text-on-sale')) {
                        priceContainer.querySelector('.discount-content sale-price').classList.add('text-on-sale');
                    }
                    let original_price = comparePrice;
                    if (parseInt(comparePrice) == 0 || comparePrice == "" || comparePrice == "null") {
                        if (priceContainer.querySelector('.discount-content compare-at-price')) {
                            priceContainer.querySelector('.discount-content compare-at-price').innerText = formatMoney(salePrice, currencyFormat);
                            priceContainer.querySelector('.discount-content compare-at-price').removeAttribute('hidden');
                        } else {
                            let compareItem = document.createElement('compare-at-price');
                            compareItem.className = "text-subdued line-through"
                            compareItem.innerText = formatMoney(salePrice, currencyFormat);
                            priceContainer.querySelector('.discount-content').appendChild(compareItem);
                        }
                        original_price = salePrice;
                    }
                    updateSaleBadge(priceContainer, newSalePrice, original_price);
                    priceContainer.classList.add('crawled');
                }
            }
        });
    } else {
        let crawledItems = document.querySelectorAll('.crawled:not(.const)');
        crawledItems.forEach((item) => {
            item.classList.remove('crawled')
        })
    }
}
async function updateItem(item, type) {
    console.log("updateItem")
    let requestBody = JSON.stringify(item);
    let requestMethod = (requestBody.includes("updates")) ? "update" : "change";
    await fetch(window.Shopify.routes.root + 'cart/' + requestMethod + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }, body: requestBody
    })
        .then(response => {
            if (response.ok) { return response.json(); }
        }).then(data => {
            // if (type == 'sys') { updateCartContent("sidebar"); }
            refreshCart();
        }).catch(error => { failCart(requestMethod); })
        .finally(() => {
            // $(".dgs-cartbar-item[loading='delete']").remove();
            // $("*[loadercover]").removeAttr("loadercover").prop("disabled", false);
        });
}

function analyzeCart(cartJSON, reload = false, mutation = false) {
    var currentCode = checkDiscountCode();
    if (!cartJSON) return false;
    var currentCart = cartJSON;
    var cartCalcKey = false;
    var cartCalcCode = false;
    var cartScriptID = false;
    var cartTransfer = false;
    var cartCalcProps = false;
    console.log("analyzeCart", currentCart, reload, mutation, parseInt(dummyInCart), dummyVarId);
    for (i = 0; i < currentCart.items.length; i++) {
        var item = currentCart.items[i];
        if (item.properties !== null) {
            if (item.variant_id == dummyVarId) {
                if (dummyInCart == 0) dummyInCart = 1;
                cartCalcKey = item.key;
                cartCalcProps = item.properties;
                cartCalcCode = ((item.properties).hasOwnProperty('__discount')) ? item.properties['__discount'] : false;
                cartCalcCode = (cartCalcCode && cartCalcCode != "none") ? cartCalcCode : false;
                if ((item.properties).hasOwnProperty('__transfer')) {
                    var transfer = item.properties['__transfer'];
                    var transferJSON = JSON.parse(transfer) ?? {};
                    transferedEvents = transferJSON.events;
                    // console.log('01: transferedEvents', transferedEvents,);
                    if (transferJSON.hasOwnProperty('fixed')) {
                        if (transferJSON.fixed) {
                            transferedEvents = prependFixedEvents(transferJSON.events, transferJSON.fixed);
                        }
                    }
                    if ((item.properties).hasOwnProperty('__tiered')) {
                        var eventIndex = transferedEvents.map(object => object.id).indexOf('tiered');
                        if (eventIndex >= 0) {
                            var tieredEvent = transferedEvents[eventIndex];
                            tieredEvent['current'] = JSON.parse(item.properties['__tiered']);
                            transferedEvents[eventIndex] = tieredEvent;
                        }
                    }
                    if (!currentCode) {
                        const splittedEvents = processObjects(transferedEvents);
                        transferedEvents = splittedEvents.otherObjects;
                        transferedBundles = splittedEvents.bundleObjects;
                    }
                    transferedGifts = transferJSON.gifts;
                    cartTransfer = true;
                }
                if ((item.properties).hasOwnProperty('__scriptid')) {
                    cartScriptID = parseInt(item.properties['__scriptid']);
                }
            }
        }
    }
    // console.log("create Dummy", dummyInCart, cartScriptID, getScriptID, cartCalcKey, cartCalcCode);
    if (parseInt(dummyInCart) == 0 && !(window.location.pathname).includes("account") && currentCode) {
        currentCode = (!currentCode) ? "none" : currentCode;
        var items = [{ 'id': parseInt(dummyVarId), 'quantity': 1, 'properties': { '__scriptid': getScriptID, '__discount': currentCode } }];
        // addItems2Cart(items, 'sys');
        fetch(`${Shopify.routes.root}cart/add.js`, {
            body: JSON.stringify({ 'items': items }),
            method: "POST",
            headers: {
                "Content-Type": "application/json"
                // Needed for Shopify to check inventory
            }
        }).then((e) => {
            // if (e.status != 404) {
            fetch('/cart.js').then((e) => e.json()).then((cartJson) => {
                // console.log("cartJson 1", cartJson);
                if (cartJson.items.length > 0) {
                    refreshCart(cartJson);
                    //refresh cart 
                    analyzeCart(cartJson);
                    calculateDiscounts();
                }
            });
            // console.log("cartJson 0", e);
            // e.json().then((cartJson) => {
            //     console.log("cartJson 1", cartJson);
            //     if (cartJson.length > 0) {
            //         refreshCart();
            //         //refresh cart 
            //         analyzeCart(cartJson);
            //         calculateDiscounts();
            //     }
            // });
            // }
        });
    } else if (cartCalcKey) {
        if (cartScriptID != getScriptID) {
            var changeProps = cartCalcProps;
            changeProps['__scriptid'] = getScriptID;
            updateItem({ 'id': cartCalcKey.toString(), 'quantity': 1, 'properties': changeProps }, 'sys');
        } else if (cartCalcCode != currentCode) {
            var changeProps = cartCalcProps;
            var changeDiscount = (currentCode) ? currentCode : 'none';
            changeProps['__discount'] = changeDiscount;
            updateItem({ 'id': cartCalcKey.toString(), 'quantity': 1, 'properties': changeProps }, 'sys');
        } else {
            // $(".dgs-cartbar-button").removeAttr('loadercover').prop("disabled", false);
            // renderDiscountFlags();
            // renderEventList();
        }
        setTimeout(() => {
            calculateDiscounts();
        }, 1500);
    }
}


function openNotification(msg = "", type = "success") {
    let cartOpen = document.querySelector('cart-drawer[open]') ? true : false,
        notibar = document.querySelector('.tantee-notificaiton-bar');
    var notiClose = 4500;
    if (msg != "" && notibar && notibar.getAttribute('open') != 'true') {
        if (!cartOpen) {
            notibar.setAttribute("msg-type", type);
            notibar.innerHTML = msg;
            notibar.setAttribute('open', 'true')
            if (notibarTimeout) { clearTimeout(notibarTimeout); }
            notibarTimeout = setTimeout(function () {
                notibar.setAttribute('open', 'false')
            }, notiClose);
        }
    }
}

function notifyDiscount() {
    var discount_code = getCookie("discount_code");
    //console.log("discount_code",discount_code);
    if (discount_code) {
        var sessionStorage_code = sessionStorage.getItem("lastDiscountCode");
        //console.log("sessionStorage_code",sessionStorage_code);
        var decodedCode = decodeURI(discount_code.trim());
        var checkCode = decodedCode.toUpperCase();
        if (sessionStorage_code === null || checkCode != sessionStorage_code) {
            let discountMsg = document.querySelector('.tantee-notificaiton-bar').getAttribute('data-discount-text');
            var codeSuccessNotiMsg = discountMsg.replace('[]', "<b>" + checkCode + "</b>");
            openNotification(codeSuccessNotiMsg, 'success');
            sessionStorage.setItem("lastDiscountCode", checkCode);
        }
    }
}

function go2checkout() {
    if (document.querySelector('.gamification') && document.querySelector('.gamification').dataset.status == "all_granted" && document.querySelector('.gamification').dataset.incart == "false") {
        if (document.querySelector('button[aria-controls="gift-leave"]')) {
            document.querySelector('button[aria-controls="gift-leave"]').click();
        }
    } else {
        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'id': dummyVarId.toString(), 'quantity': 0 })
        })
            .then(response => {
                window.location = '/checkout';
            });
    }

}